import { AutocompleteOption } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { v4 } from 'uuid';
import { Select } from '../../../../../design/inputs/select/Select';
import { S_ClampLines } from '../../../../../design/misc/S_ClampLines';
import { IAnswerModel } from '../../question.model';

interface IAnswerDropDownProps {
  answers: IAnswerModel[];
  disabled: boolean;
  onAnswered: (answer: string) => void;
}

export const AnswerDropDown = observer(({ answers, disabled, onAnswered }: IAnswerDropDownProps): ReactElement => {
  return (
    <Select
      slotProps={{
        input: { tabIndex: 1 },
      }}
      disableClearable={false}
      disabled={disabled}
      value={answers.find((a) => a.selected)}
      options={answers}
      getOptionLabel={(option) => option.text}
      onChange={(_, v) => {
        onAnswered(v?.id ?? '');
      }}
      renderOption={(props, option) => (
        <AutocompleteOption {...props}>
          <S_ClampLines
            id={`answer-${v4()}`}
            text={option.text}
            lines={20}
            innerElement={'div'}
          />
        </AutocompleteOption>
      )}
    />
  );
});
